import { i18n } from '@/locales';
const t = i18n.t.bind(i18n);
const lc = 'views.allocated_cancel_penalty_group.';
export const allocatedCancelPenaltyGroupGroupTableHeader = [
    {
        title: t(`${lc}group_table.group_name`),
        align: 'start',
        sortable: true,
        value: 'name',
        width: 280,
    },
    {
        title: t(`${lc}group_table.worker_in_group`),
        align: 'end',
        sortable: false,
        width: 160,
    },
];
export const allocatedCancelPenaltyGroupOptionTableHeader = [
    {
        title: t(`${lc}option_table.penalty_start_count`),
        align: 'end',
        sortable: false,
        width: 172,
    },
    {
        title: t(`${lc}option_table.penalty_amount`),
        align: 'end',
        sortable: false,
        width: 152,
    },
];
export const allocatedCancelPenaltyGroupWorkerListTableHeader = [
    {
        title: t(`${lc}worker_list_dialog.worker_list_table.worker_name`),
        align: 'start',
        sortable: false,
        // 가로 스크롤 이슈 해결을 위한 주석
        // https://barogo.slack.com/archives/C04UP4VFCKA/p1697592326185089
        // width: 382,
    },
    {
        title: t(`${lc}worker_list_dialog.worker_list_table.worker_code`),
        align: 'start',
        sortable: false,
        width: 94,
    },
    {
        title: t(`${lc}worker_list_dialog.worker_list_table.worker_number`),
        align: 'start',
        sortable: false,
        width: 120,
    },
];
